import { render, staticRenderFns } from "./PunchCode.vue?vue&type=template&id=3ca50d91&scoped=true&"
import script from "./PunchCode.vue?vue&type=script&lang=js&"
export * from "./PunchCode.vue?vue&type=script&lang=js&"
import style0 from "./PunchCode.vue?vue&type=style&index=0&id=3ca50d91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca50d91",
  null
  
)

export default component.exports